import React from "react";
import { use$, useUnmount } from "@legendapp/state/react";
import { useUpdateEffect } from "primereact/hooks";
import DataExportListStore$ from "reports/data-export/data-export-list/stores/DataExportListStore";
import Table from "reports/data-export/data-export-list/components/Table";
import useGetDataExportList from "reports/data-export/data-export-list/hooks/useGetDataExportList";

const DataExportList = () => {
  const { data, loading } = useGetDataExportList({
    filters: use$(DataExportListStore$.tableState.filters),
    page: use$(DataExportListStore$.tableState.page),
    rows: use$(DataExportListStore$.tableState.rows),
    sortOrder: use$(DataExportListStore$.tableState.sortOrder),
    updatedEntities: use$(DataExportListStore$.tableState.updatedEntities),
  });

  // Execute when data changes
  useUpdateEffect(() => {
    if (data.meta?.status === "OK") {
      DataExportListStore$.assign({
        tableData: data.data,
        totalRecords: data.data?.length || 0,
      });
    }
  }, [data]);

  useUnmount(() => {
    DataExportListStore$.reset();
  });

  return <Table isLoading={loading} />;
};

export default DataExportList;
